import React from 'react';
import emgImg from "../../assets/images/404.svg"; // Import the 404 image
import { BASE_URL } from '../../constants/Constants';
import { useNavigate } from 'react-router-dom';
import imgCivic from "../../assets/civicPlanLogo.png";

interface CustomErrorPageProps {
  errorCode?: number;
}

const CustomErrorPage: React.FC<CustomErrorPageProps> = ({ errorCode }) => {
  let errorMessage = "Oops! Something went wrong";
  let errorDescription = "We're sorry, but we couldn't process your request at this time.";
  const navigate = useNavigate();

  if (errorCode === 404) {
    errorMessage = "404 - Page Not Found";
    errorDescription = "The page you're looking for doesn't exist or has been moved.";
  } else if (errorCode === 403) {
    errorMessage = "403 - Forbidden";
    errorDescription = "You don't have permission to access this resource.";
  }

  return (

    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="w-full bg-white shadow-md p-4">
        <div className="container mx-auto">
          <img
            // src={`${BASE_URL}/api/logo`}
            src={imgCivic}
            alt="Logo"
            className="h-12 w-auto"
          />
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-grow flex flex-col items-center justify-center p-4">
  <div className="text-center">
    <h1 className="text-yellow-500 text-4xl font-bold mb-2">OOPS!</h1>
    <p className="text-gray-600 text-xl ">Page not found</p>

    <div className=" max-w-lg mx-auto">
      <img
        src={emgImg}
        alt="404 Not Found"
        className="img-fluid"
        style={{
          width: '500px',  // Increase width
          height: '400px', // Increase height
        }}
      />
    </div>

    <button
      onClick={() => navigate(-1)}
      className="bg-black px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
    >
      Back
    </button>
  </div>
</div>
    </div>

  );
};

export default CustomErrorPage;
